import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const SUB = [
  { label: "EU Heritage", href: "/eu-heritage", desc: "Il mosaico culturale europeo, paese per paese." },
  { label: "EU – CEE", href: "/eu-cee", desc: "Dalla Comunità Economica Europea (1957) all'Unione Europea (1992)." },
  { label: "The Road to 27", href: "/road-to-27", desc: "La storia degli allargamenti dal 1958 a oggi." },
  { label: "EU – Euro", href: "/eu-euro", desc: "L'euro e i 21 Stati che lo adottano: storia e politiche." },
  { label: "Europe's Languages", href: "/eu-languages", desc: "24 lingue ufficiali UE: identità nel multilinguismo." },
];

const REGIONS = [
  { region: "Heart of the Continent", list: ["Austria", "Belgium"] },
  { region: "Eastern Europe", list: ["Bulgaria", "Romania"] },
  { region: "Balkans", list: ["Croatia", "Slovenia"] },
  { region: "Mediterranean", list: ["Cyprus", "Malta"] },
  { region: "Central Europe", list: ["Czech Republic", "Slovakia"] },
  { region: "Northern Europe", list: ["Denmark", "Finland", "Sweden"] },
  { region: "Baltic", list: ["Estonia", "Latvia", "Lithuania"] },
  { region: "Western Europe", list: ["France", "Germany", "Luxembourg"] },
  { region: "Southeastern", list: ["Greece"] },
  { region: "English-speaking", list: ["Ireland"] },
  { region: "Southern Europe", list: ["Italy", "Spain", "Portugal"] },
  { region: "Central-Eastern", list: ["Hungary", "Poland"] },
  { region: "Integration core", list: ["Netherlands"] },
];

export default function EUToday() {
  return (
    <PageShell>
      <PageHero
        eyebrow="— EU Today"
        title={
          <>
            27 paesi, <span className="italic">450,4 milioni</span> di cittadini.
          </>
        }
        subtitle="La Comunità Europea (Unione Europea) si compone di 27 paesi membri e di una popolazione totale di 450,4 milioni di abitanti: una geografia plurale che attraversa Mediterraneo, Atlantico, Baltico, Carpazi e Alpi."
      />

      <section className="bg-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-8 reveal">
            {REGIONS.map((r) => (
              <div key={r.region} className="border-t border-[#e2e8f0] pt-5">
                <span className="text-[10.5px] tracking-[0.32em] uppercase text-[#d4af37] font-body">
                  {r.region}
                </span>
                <ul className="mt-3 space-y-1.5">
                  {r.list.map((c) => (
                    <li
                      key={c}
                      className="font-display text-xl md:text-2xl text-[#1a365d] leading-snug"
                    >
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#fafaf7] py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="mb-12 reveal">
            <span className="eyebrow">— Approfondimenti</span>
            <h2 className="font-display text-3xl md:text-5xl text-[#1a365d] mt-4 leading-tight">
              Esplora la sezione <span className="italic">EU Today</span>.
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SUB.map((s, i) => (
              <Link
                key={s.href}
                to={s.href}
                className={`group block bg-white border border-[#e2e8f0] hover:border-[#d4af37] p-7 md:p-8 transition-colors card-lift reveal delay-${(i % 3) + 1}`}
              >
                <span className="text-[10.5px] tracking-[0.28em] uppercase text-[#d4af37] font-body">
                  0{i + 1}
                </span>
                <h3 className="font-display text-xl md:text-2xl text-[#1a365d] mt-3 leading-snug group-hover:text-[#d4af37] transition-colors">
                  {s.label}
                </h3>
                <p className="font-body text-[#475569] text-[14px] leading-relaxed mt-3">
                  {s.desc}
                </p>
                <span className="mt-5 inline-flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-[#1a365d] group-hover:text-[#d4af37] transition-colors font-medium">
                  Open <ArrowUpRight size={12} strokeWidth={2} />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
